import React from 'react';
import { Link } from 'src/components/Inputs';

/*
 * When making changes to this file be sure that any changes
 * also are made to the corresponding iOS specific counterpart
 * in src/pages/<lang>/legal/ios.jsx.
 */

const EEANLEndUserServicesAgreement = () => {
  return (
    <>
      <h4
        id='end-user-services-agreement-eea-nl'
        data-magellan-target='end-user-services-agreement-eea-nl'
      >
        Dienstenovereenkomst voor eindgebruikers (EEA)
      </h4>
      <p>Laatst bijgewerkt: 22 Februari 2021</p>
      <p>Hartelijk dank dat u Plaid gebruikt!</p>
      <p>
        Deze Dienstenovereenkomst voor eindgebruikers (‘
        <strong>Overeenkomst</strong>’) is een juridische overeenkomst tussen
        Plaid, BV (‘
        <strong>Plaid</strong>’, ‘<strong>we/wij</strong>’ of ‘
        <strong>ons/onze</strong>’) en de eindgebruiker van onze Diensten ‘
        <strong>u</strong>’, ‘<strong>uw</strong>’).Deze Overeenkomst is
        uitsluitend van toepassing als wij u rekeninginformatiediensten en
        betalingsinitiatiediensten (in de zin van de herziene Europese Richtlijn
        (EU) 2015/2366 betreffende betalingsdiensten in de interne markt)
        leveren met betrekking tot een betaalrekening in Nederland of de
        Europese Economische Ruimte (EER) en als we opgehaalde gegevens en/of de
        betalingsstatus die aan dergelijke diensten zijn gerelateerd, namens u
        doorgeven aan derden (‘<strong>Diensten</strong>’). Dergelijke derden
        zijn onder meer de eigenaar of verstrekker van de web-, desktop- en/of
        mobiele applicatie waarmee u onze Diensten heeft geopend (‘
        <strong>Applicable</strong>’).
      </p>
      <p>
        Deze Overeenkomst beschrijft de algemene voorwaarden die van toepassing
        zijn op uw gebruik van de Diensten. U mag de Diensten alleen openen of
        gebruiken als u toezegt alle voorwaarden in deze Overeenkomst te zullen
        naleven. U dient deze Overeenkomst dan ook nauwkeurig te lezen en te
        zorgen dat u deze begrijpt. Als u een of meer voorwaarden in deze
        Overeenkomst niet begrijpt, neem dan alvorens de Diensten te gebruiken
        contact met ons op door een e-mail te sturen naar{' '}
        <Link href='mailto:regulatory@plaid.com'>
          <a>regulatory@plaid.com</a>
        </Link>
      </p>
      <p>
        Een bijgewerkte versie van de Overeenkomst kunt u op elk moment inzien
        op{' '}
        <Link href='https://plaid.com/legal/'>
          <a>https://plaid.com/legal/</a>
        </Link>
        .
      </p>
      <p>
        <em>Spring naar onderdeel:</em>
      </p>
      <p>
        <Link href='#plaid-nl'>
          <a data-smooth-scroll data-offset='80'>
            Plaid
          </a>
        </Link>
      </p>
      <p>
        <Link href='#diensten-van-plaid-nl'>
          <a data-smooth-scroll data-offset='80'>
            Diensten van Plaid
          </a>
        </Link>
      </p>
      <p>
        <Link href='#communicatie-nl'>
          <a data-smooth-scroll data-offset='80'>
            Communicatie
          </a>
        </Link>
      </p>
      <p>
        <Link href='#gegevens-nl'>
          <a data-smooth-scroll data-offset='80'>
            Gegevens
          </a>
        </Link>
      </p>
      <p>
        <Link href='#aansprakelijkheid-nl'>
          <a data-smooth-scroll data-offset='80'>
            Aansprakelijkheid
          </a>
        </Link>
      </p>
      <p>
        <Link href='#klachten-nl'>
          <a data-smooth-scroll data-offset='80'>
            Klachten
          </a>
        </Link>
      </p>
      <p>
        <Link href='#wijzigingen-in-deze-overeenkomst-nl'>
          <a data-smooth-scroll data-offset='80'>
            Wijzigingen in deze Overeenkomst
          </a>
        </Link>
      </p>
      <p>
        <Link href='#beëindiging-nl'>
          <a data-smooth-scroll data-offset='80'>
            Beëindiging
          </a>
        </Link>
      </p>
      <p>
        <Link href='#toepasselijk-recht-en-taal-nl'>
          <a data-smooth-scroll data-offset='80'>
            Toepasselijk recht en taal
          </a>
        </Link>
      </p>

      <p id='plaid-nl'>
        <strong>1. Plaid</strong>
      </p>
      <p>
        1.1. Plaid, BV (RSIN 860002652) heeft ingevolge de Payment Services
        Regulations 2017 van De Nederlandsche Bank N.V. een vergunning gekregen
        voor het verlenen van rekeninginformatiediensten (RID) en is
        geregistreerd bij De Nederlandsche Bank N.V. onder nummer R179714.
      </p>
      <p>
        1.2. Plaid is statutair gevestigd te Muiderstraat 1, 1011 PZ Amsterdam,
        Nederland. Het kantooradres van Plaid is Suite 3A03, Singel 542, 1017 AZ
        Amsterdam, Nederland.
      </p>

      <p id='diensten-van-plaid-nl'>
        <strong>2. Diensten van Plaid</strong>
      </p>
      <p>
        2.1. U heeft onze Diensten geopend via een Applicatie of in het
        dashboard van Plaid (beschikbaar via{' '}
        <Link href='https://my.plaid.com/'>
          <a>https://my.plaid.com/</a>
        </Link>{' '}
        ). De producten en diensten die u worden verstrekt door de Applicatie
        worden beheerst door een afzonderlijke overeenkomst tussen u en de
        leverancier van de Applicatie (‘
        <strong>Applicatievoorwaarden</strong>
        ’). Wij zijn niet verantwoordelijk voor de producten en diensten die u
        worden geleverd door of via de Applicatie en aanvaarden geen enkele
        aansprakelijkheid voor nadeel, verlies of schade voortvloeiend uit uw
        gebruik van de producten en diensten geleverd door of via de Applicatie.
      </p>
      <p>
        2.2. Onze Diensten stellen u in staat financiële informatie te
        verkrijgen van uw online bank- of betaalrekening (‘
        <strong>Betaalrekening</strong>’) (rekeninginformatiediensten).
      </p>
      <p>
        2.3. De algemene voorwaarden die van toepassing zijn op de
        Betaalrekeningen die u via onze Diensten kunt openen (de ‘
        <strong>Rekeningvoorwaarden</strong>’) blijven van kracht en deze
        Overeenkomst wijzigt niets aan uw Rekeningvoorwaarden.
      </p>
      <p>
        2.4. Wij brengen u geen kosten in rekening voor het gebruik van onze
        Diensten. Applicaties of andere derden kunnen echter wel kosten in
        rekening brengen voor aan u geleverde producten en diensten die
        gebruikmaken van de door Plaid uit hoofde van deze Overeenkomst
        verleende Diensten. In bepaalde gevallen betalen leveranciers van
        applicaties en andere derden ons een vergoeding in verband met de
        diensten die wij aan hen leveren.
      </p>
      <p>
        <span style={{ textDecoration: 'underline' }}>
          Rekeninginformatiediensten
        </span>
      </p>
      <p>
        2.5. De rekeninginformatiediensten van Plaid stellen u in staat
        informatie betreffende de door u geselecteerde Betaalrekening te openen
        en te bekijken in het Plaid-dashboard (beschikbaar op{' '}
        <Link href='https://my.plaid.com/'>
          <a>https://my.plaid.com/</a>
        </Link>{' '}
        ) en de Applicatie waarmee u onze Diensten heeft geopend.
      </p>
      <p>
        2.6. Om het Plaid-dashboard te openen, dient u bij Plaid een account aan
        te maken. U dient daarnaast te zorgen dat uw gegevens juist, volledig en
        actueel zijn. U dient ‘best practices’ te volgen om uw Plaid-account te
        helpen beveiligen en moet ons op de hoogte brengen van onbevoegde
        toegang tot of onbevoegd gebruik van uw Plaid-account zodra dit u ter
        kennis komt.
      </p>
      <p>
        2.7. Met uw expliciete toestemming openen en tonen wij informatie
        betreffende uw geselecteerde Betaalrekening(en) (‘
        <strong>Rekeninginformatie</strong>’) in het Plaid-dashboard en geven
        dergelijke informatie door aan de Applicatie waarmee u onze Diensten
        heeft geopend. Dergelijke informatie betreft onder meer:
      </p>
      <p>
        (a) financiële transactiehistorie, zoals transactiebedrag, -data,
        -beschrijving en -valuta;
      </p>
      <p>
        (b) financiële details betreffende de Betaalrekening, zoals
        rekeningnummer, -type, -valuta en -saldo; en
      </p>
      <p>
        (c) informatie betreffende de rekeninghouder, zoals naam, adres,
        telefoonnummer en e-mailadres.
      </p>
      <p>
        2.8. Alvorens de rekeninginformatiediensten van Plaid te ontvangen,
        heeft u de Applicatie waarmee u onze Diensten heeft geopend opdracht
        gegeven uw rekeninginformatie op te halen met gebruik van Plaid. Na een
        dergelijke opdracht wordt u in het algemeen naar ons doorgeleid.
      </p>
      <p>
        2.9. Nadat u naar ons bent doorgeleid, vragen wij u de aanbieder van de
        Betaalrekening (‘<strong>Rekeningaanbieder</strong>’) te selecteren die
        wij moeten gebruiken om uw Rekeninginformatie te openen. U geeft ons uw
        expliciete toestemming: (i) om uw Rekeninginformatie te openen bij de
        door u geselecteerde Rekeningaanbieder; en (ii) de in artikel 2.12 van
        deze Overeenkomst vermelde stappen te nemen nadat wij uw
        Rekeninginformatie hebben geopend. Plaid vraagt overeenkomstig uw
        toestemming periodiek uw Rekeninginformatie aan uw Rekeningaanbieder en
        wel tot het moment waarop de toestemming vervalt of wordt ingetrokken.
      </p>
      <p>
        2.10. Wij wijzen u erop dat het kan gebeuren dat u wordt doorgeleid naar
        de website of mobiele applicatie van uw Rekeningaanbieder om uw
        identiteit te verifiëren, zodat uw Rekeningaanbieder weet dat wij uw
        Rekeninginformatie openen met uw toestemming.
      </p>
      <p>
        2.11. Het kan onder omstandigheden ook gebeuren dat wij u vragen ons de
        inloggegevens van uw Betaalrekening te verstrekken. Door ons de
        inloggegevens van uw Betaalrekening te verstrekken, bevestigt u dat u
        alle benodigde rechten, toestemmingen en bevoegdheden heeft om uw
        inloggegevens en Rekeninginformatie met ons te delen en geeft u ons
        expliciet toestemming om uw inloggegevens te gebruiken om uw
        Betaalrekening in te zien om namens en in opdracht van u de nodige
        Rekeninginformatie te verkrijgen teneinde u de Diensten te kunnen
        verlenen.
      </p>
      <p>2.12. Nadat wij uw Rekeninginformatie hebben geopend, kunnen wij:</p>
      <p>
        (a) uw Rekeninginformatie delen met de Applicatie waarmee u onze
        Diensten heeft geopend;
      </p>
      <p>
        (b) uw Rekeninginformatie delen met derden volgens de aanwijzingen van
        de Applicatie waarmee u onze Diensten heeft geopend, echter op
        voorwaarde dat u daartoe expliciet toestemming heeft gegeven; of
      </p>
      <p>(c) uw Rekeninginformatie weergeven in het Plaid-dashboard.</p>
      <p>
        2.13. U stemt ermee in dat wij de Rekeninginformatie die wij bij uw
        Rekeningaanbieder hebben geopend, delen met de Applicatie waarmee u onze
        Diensten heeft geopend en op aanwijzing van die Applicatie ook met
        derden, in beide gevallen op voorwaarde dat u daartoe expliciet
        toestemming heeft gegeven. Het delen van de informatie stelt de
        Applicatie in staat u producten en diensten te leveren in
        overeenstemming met de Applicatievoorwaarden.
      </p>
      <p>
        2.14. Wij controleren de Rekeninginformatie opgehaald van uw
        Rekeningaanbieder niet op juistheid en vertrouwen erop dat uw
        Rekeningaanbieder zorgt dat uw Rekeninginformatie actueel en juist is.
      </p>
      <p>
        2.15. Wij kunnen uw Rekeninginformatie standaardiseren, categoriseren,
        samenvoegen, aggregeren en anderszins verwerken alvorens deze te tonen
        in het Plaid-dashboard, te delen met de Applicatie waarmee u onze
        Diensten heeft geopend of te delen met derden op aanwijzing van die
        Applicatie en met uw expliciete toestemming.
      </p>
      <p>
        2.16. U kunt uw toestemming aan Plaid om rekeninginformatiediensten te
        verlenen op elk gewenst moment intrekken of wijzigen.
      </p>
      <p>
        <span style={{ textDecoration: 'underline' }}>
          Voorwaarden voor gebruik en beschikbaarheid
        </span>
      </p>
      <p>2.17. U kunt de Diensten uitsluitend gebruiken indien:</p>
      <p>(a) u 18 jaar of ouder bent;</p>
      <p>
        (b) uw Betaalrekening en Rekeningaanbieder zijn gevestigd in Nederland
        of een ander land in de EER;
      </p>
      <p>
        (c) u ons juiste, volledige en actuele informatie verstrekt en geen
        verkeerde voorstelling geeft omtrent uw identiteit of andere informatie
        betreffende uzelf;
      </p>
      <p>
        (d) u instemt met deze Overeenkomst en met het gebruik van onze Diensten
        in overeenstemming met deze Overeenkomst; en
      </p>
      <p>
        (e) u toezegt alle wet- en regelgeving die van toepassing is op uw
        gebruik van de Diensten te zullen naleven.
      </p>
      <p>
        2.18. Welke Diensten beschikbaar zijn en hoe deze worden geleverd kan
        variëren afhankelijk van het type apparaat dat u gebruikt, het type
        Betaalrekening(en) dat u heeft, de Rekeningvoorwaarden en de
        Applicatievoorwaarden.
      </p>

      <p id='communicatie-nl'>
        <strong>3. Communicatie</strong>
      </p>
      <p>
        3.1. Waar relevant kan Plaid u informatie en berichten sturen naar uw
        e-mailadres of via SMS naar uw mobiele telefoonnummer als Plaid dat
        nodig acht.
      </p>
      <p>
        3.2. In geval van wijziging van uw contactgegevens (zoals uw mobiele
        telefoonnummer of e-mailadres) dient u ons daar zo snel mogelijk van op
        de hoogte te brengen. U bent zelf verantwoordelijk voor het onderhouden
        en regelmatig controleren van uw apparaat of e-mailbox op informatie en
        berichten van Plaid.
      </p>
      <p>
        3.3. U kunt per e-mail contact opnemen met Plaid via{' '}
        <Link href='mailto:regulatory@plaid.com'>
          <a>regulatory@plaid.com</a>
        </Link>
      </p>

      <p id='gegevens-nl'>
        <strong>4. Gegevens</strong>
      </p>
      <p>
        4.1. Wij gebruiken uw informatie overeenkomstig ons Privacybeleid voor
        eindgebruikers (‘<strong>Privacybeleid</strong>’), dat u kunt vinden op
        onze website via{' '}
        <Link href='#privacybeleid-voor-eindgebruikers'>
          <a>https://plaid.com/legal/#privacybeleid-voor-eindgebruikers</a>
        </Link>{' '}
        . Als u zich niet kunt vinden in de manier waarop we uw informatie
        hanteren zoals uiteengezet in het Privacybeleid, moet u onze diensten
        niet gebruiken.
      </p>

      <p id='aansprakelijkheid-nl'>
        <strong>5. Aansprakelijkheid</strong>
      </p>
      <p>
        5.1. Plaid is niet aansprakelijk en niet verplicht u te vergoeden voor
        verliezen als gevolg van omstandigheden waarover wij geen controle
        hebben, zoals extreme weersomstandigheden, terroristische activiteiten
        of industriële acties.
      </p>
      <p>
        5.2. Plaid is niet aansprakelijk voor overtreding van een vereiste
        opgelegd door of krachtens toepasselijke Nederlandse financiële wet- en
        regelgeving, indien de overtreding het gevolg is van:
      </p>
      <p>
        (a) abnormale of onvoorziene omstandigheden waarover Plaid geen controle
        heeft en waarvan de gevolgen onvermijdbaar zouden zijn geweest ondanks
        pogingen om ze te voorkomen; of
      </p>
      <p>
        (b) de verplichtingen van Plaid op grond van andere bepalingen van EU-
        of nationaal recht.
      </p>
      <p>
        5.3. Niets strekt echter tot uitsluiting of beperking van onze
        aansprakelijkheid voor:
      </p>
      <p>
        (a) door onze nalatigheid veroorzaakt(e) dood of persoonlijk letsel;
      </p>
      <p>(b) fraude of frauduleuze voorstelling van zaken onzerzijds; of</p>
      <p>
        (c) een opzettelijke, ernstige schending van deze Overeenkomst met de
        bedoeling u schade te berokkenen.
      </p>
      <p>
        5.4. Wij zijn jegens u niet aansprakelijk voor nadeel, schade of verlies
        voortvloeiend uit het handelen of nalaten van derden, in het bijzonder
        van uw Rekeningaanbieder(s) of de Applicatie waarmee u onze Diensten
        heeft geopend.
      </p>

      <p id='klachten-nl'>
        <strong>6. Klachten</strong>
      </p>
      <p>
        6.1. Als u een klacht heeft over onze Diensten, verzoeken wij u een
        e-mail te sturen naar{' '}
        <Link href='mailto:regulatory@plaid.com'>
          <a>regulatory@plaid.com</a>
        </Link>{' '}
        zodat Plaid de omstandigheden kan onderzoeken. Wij streven ernaar
        klachten over onze Diensten snel en eerlijk te behandelen, in
        overeenstemming met onze verplichtingen ingevolge toepasselijk recht.
        Plaid kan u echter eventueel doorverwijzen naar:
      </p>
      <p>
        (a) uw Rekeningaanbieder, als uw klacht betrekking heeft op de diensten
        uit hoofde van de Rekeningvoorwaarden; of
      </p>
      <p>
        (b) de Applicatie waarmee u onze Diensten heeft geopend, als uw klacht
        betrekking heeft op de door de Applicatie ingevolge de
        Applicatievoorwaarden geleverde producten en/of diensten.
      </p>
      <p>
        6.2. Als uw klacht betrekking heeft op onze Diensten en wij de klacht
        niet afhandelen, kunt u deze neerleggen bij het Klachteninstituut
        Financiële Dienstverlening, Kifid. U kunt als volgt contact opnemen met
        het Klachteninstituut Financiële Dienstverlening: telefonisch via nummer
        +3170 333 89 99, van maandag t/m vrijdag van 09.00 uur tot 17.00 uur en
        zaterdag van 09.00 uur tot 13.00 uur; per post door te schrijven aan
        adres Kifid, Postbus 93257, 2509 AG Den Haag, of per e-mail door een
        bericht te sturen naar{' '}
        <Link href='mailto:consumenten@kifid.nl'>
          <a>consumenten@kifid.nl</a>
        </Link>
        .
      </p>
      <p>
        6.3. Plaid is evenmin verantwoordelijk voor klachten of geschillen over
        producten en/of diensten geleverd door de Applicatie waarmee u onze
        Diensten heeft geopend, over andere derden of over uw Rekeningaanbieder.
        Dergelijke klachten moet u rechtstreeks richten aan de Applicatie, de
        derde of de Rekeningaanbieder.
      </p>

      <p id='wijzigingen-in-deze-overeenkomst-nl'>
        <strong>7. Wijzigingen in deze Overeenkomst</strong>
      </p>
      <p>
        7.1. Plaid behoudt zich het recht voor deze Overeenkomst op elk gewenst
        moment te wijzigen. Bij voorgenomen wijzigingen neemt Plaid uw belangen
        in beschouwing en voeren wij uitsluitend wijzigingen door die door ons
        redelijk worden geacht.
      </p>
      <p>
        7.2. Van elke voorgenomen wijziging in deze Overeenkomst stellen wij u
        ten minste twee maanden van tevoren schriftelijk op de hoogte via (in
        elk geval) de contactgegevens die u ons heeft verstrekt, onder
        bijvoeging van de nieuwe versie van de Overeenkomst.
      </p>
      <p>
        7.3. Indien u niet kunt instemmen met de voorgestelde wijziging(en),
        dient u ons daar voorafgaand aan de inwerkingtreding van de wijziging
        van in kennis te stellen met gebruikmaking van de in artikel 3.3
        vermelde contactgegevens van Plaid. U heeft steeds het recht om deze
        Overeenkomst voor de voorgestelde datum van inwerkingtreding te
        beëindigen. Als u ons niet laat weten dat u de wijzigingen niet
        aanvaardt en niet verzoekt om beëindiging van deze Overeenkomst, wordt u
        geacht de wijziging(en) in de Overeenkomst te hebben aanvaard.
      </p>

      <p id='beëindiging-nl'>
        <strong>8. Beëindiging</strong>
      </p>
      <p>
        8.1. Het contract tussen u en Plaid dat wordt uiteengezet in deze
        Overeenkomst en dat ziet op uw gebruik van de Diensten, duurt voort
        totdat het overeenkomstig dit artikel 8 wordt beëindigd.
      </p>
      <p>
        8.2. U heeft het recht het contract tussen ons dat in deze Overeenkomst
        wordt uiteengezet, op elk moment en zonder opzegtermijn te beëindigen
        door contact op te nemen met Plaid via de in artikel 3.3 vermelde
        contactgegevens van Plaid.
      </p>
      <p>
        8.3. Wij kunnen het contract met u met onmiddellijke ingang schriftelijk
        beëindigen:
      </p>
      <p>
        (a) indien u deze Overeenkomst herhaaldelijk schendt en de betreffende
        aangelegenheid niet tijdig naar tevredenheid van Plaid oplost, en
      </p>
      <p>(b) in geval van uw overlijden of onbekwaamheid.</p>
      <p>
        8.4. Wij kunnen deze Overeenkomst met u om welke reden dan ook
        schriftelijk beëindigen met inachtneming van een opzegtermijn van ten
        minste twee maanden.
      </p>

      <p id='toepasselijk-recht-en-taal-nl'>
        <strong>9. Toepasselijk recht en taal</strong>
      </p>
      <p>
        9.1. Deze Overeenkomst en alle geschillen of vorderingen (met inbegrip
        van niet-contractuele geschillen of vorderingen) die ontstaan uit of in
        verband met deze Overeenkomst of het onderwerp of de totstandkoming
        ervan, worden bij uitsluiting beheerst door Nederlands recht.
      </p>
      <p>
        9.2. Deze Overeenkomst is beschikbaar in het Engels en in het
        Nederlands. Alle communicatie met u geschiedt in het Engels.
      </p>

      <hr className='section-divider' />
    </>
  );
};

export default EEANLEndUserServicesAgreement;
